import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../environments/environment";

import { ReCaptchaComponent } from 'angular2-recaptcha';

import { LookupService } from "../../services/lookups/lookup.service";

import { AuthService } from "../../services/auth/auth.service";
import { Subscription } from "rxjs/Subscription";
import { NotificationComponent } from "../shared/notification.component";
import { LocalStorageService } from "../../services/shared/localStorage.service";

//import { tokenNotExpired } from "angular2-jwt";

@Component({
    selector: 'app-login',
    templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
    @ViewChild('notification') notificationComponent: NotificationComponent;
    @ViewChild(ReCaptchaComponent) captcha: ReCaptchaComponent;

    frm: FormGroup;

    loggedIn: boolean = false;

    isCaptchaOk: boolean = false;
    reCaptchaSiteKey: string = "";

    returnUrl: string;

    constructor(private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
        private lookupService: LookupService,
        private lsService: LocalStorageService) { }

    onPasswordReset: Subscription;
    onFormValueChanged: Subscription;

    showInfo: boolean = false;
    loading: boolean = false;
    currentHref: string = "";

    ngOnInit() {
        // this.reCaptchaSiteKey = this.lookupService.getReCaptchaSiteKey();

        this.lookupService.getReCaptchaSiteKey().subscribe(
            (response: string) => {
              this.reCaptchaSiteKey = response;
            },
            (error) => {
              console.log(error.message);
            }
          );
          
        this.currentHref = window.location.href;
        this.loggedIn = this.authService.isAuthenticated();
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

        let ru: { userName: string, pwd: string, rememberMe: boolean } = { userName: "", pwd: "", rememberMe: false };

        this.frm = new FormGroup(
            {
                'username': new FormControl(null, [Validators.required, Validators.email])
            }
        );

        this.onFormValueChanged = this.frm.valueChanges.subscribe(data => { this.notificationComponent.clear(); })

        this.onPasswordReset = this.authService.passwordReset
            .subscribe(
            (response: any) => {
                if (response == null) {
                    this.notificationComponent.animateErrorAction("There was an error when processing your request");
                }
                else {
                    if (response != null && response.isSuccess) {
                        this.showInfo = true;
                    } else {
                        this.showInfo = true;
                    }
                }

                this.loading = false;
            });
    }

    ngOnDestroy() {
        this.onPasswordReset.unsubscribe();
        this.onFormValueChanged.unsubscribe();
    }

    onCaptchaResponse(e) {
        //let token = this.captcha.getResponse();
        this.isCaptchaOk = true;
    }
    onCaptchaExpired(e) {
        this.isCaptchaOk = false;
    }

    onResetPassword() {
        this.showInfo = false;
        this.loading = true;

        const username = this.frm.value.username;
        this.authService.resetPassword(username, this.currentHref);
    }

    onClear() {
        this.frm.value.username = null;

        this.frm.reset();
    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/anon/reset-password.component.ts